import React from 'react';
import { useSelector } from 'react-redux';
import { InputNumber } from 'antd';
import classnames from 'classnames';

/**
 * An amount in major units, with `precision` decimals (2 unless the caller
 * says otherwise — e.g. 0 for a currency guests pay in whole units, such as
 * COP or CLP).
 */
export default function CurrencyInput({
  value,
  onChange,
  disabled,
  id,
  currency,
  className,
  placeholder,
  precision = 2,
}) {
  const { company } = useSelector((state) => state.currentCompany);
  const { serviceProvider } = useSelector((state) => state.currentServiceProvider);

  const _currency =
    currency ?? company?.currency ?? serviceProvider?.currency ?? serviceProvider?.regional_config?.currency;

  const formatter = (value) => {
    const [whole, fraction] = value.split('.');

    if (fraction === undefined) {
      return value;
    }

    return precision === 0 ? whole : `${whole}.${fraction.slice(0, precision)}`;
  };

  return (
    <InputNumber
      value={value}
      formatter={formatter}
      onChange={onChange}
      disabled={disabled}
      id={id}
      step={10 ** -precision}
      prefix={<span className="border-r border-gray-300 pr-2 mr-2 text-gray-500">{_currency}</span>}
      className={classnames('w-full', className)}
      placeholder={placeholder}
    />
  );
}
